import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#01B9FF",
    },
  },
  typography: {
    fontFamily: ["Raleway", "sans-serif", "serif"].join(","),
    h1: {
      fontSize: "3em",
    },
    h3: {
      fontSize: "2em",
    },
    h4: {
      fontSize: "1.3em",
    },
    h5: {
      fontSize: "1.5em",
      fontWeight: "bold",
    },
    h6: {
      fontSize: "1.25em",
    },
    body1: {
      fontSize: "14px",
    },
    caption: {
      fontSize: "12px",
      lineHeight: "1.25",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: "bold",
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        underline: {
          "&:hover:not(.Mui-disabled):before": {
            borderBottom: "2px solid #06ad38",
          },
        },
        inputMultiline: {
          lineHeight: 1.6,
        },
      },
    },
  },
});

export default theme;
